import React from 'react';
import StepConnector from '@mui/material/StepConnector';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

const CustomStepConnector = withStyles({
  line: {
    borderTopWidth: '2px !important',
    borderColor: '#3C607A !important',
  },
})(StepConnector);

const UiStepConnector = (props) => {
  const { children, className, ...restProps } = props;
  return (
    <CustomStepConnector className={className} {...restProps}>
      {children}
    </CustomStepConnector>
  );
};

UiStepConnector.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default UiStepConnector;
